<template>
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold text-center mb-8 text-gray-700">
      Список врачей и медсестёр
    </h1>
    <div class="flex justify-center items-center space-x-4 mb-6">
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Поиск по имени..."
        class="w-1/3 px-4 py-2 border rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <button
        @click="filterStaff('all')"
        :class="filter === 'all' ? activeClass : defaultClass"
      >
        Все
      </button>
      <button
        @click="filterStaff('doctor')"
        :class="filter === 'doctor' ? activeClass : defaultClass"
      >
        Врачи
      </button>
      <button
        @click="filterStaff('nurse')"
        :class="filter === 'nurse' ? activeClass : defaultClass"
      >
        Медсёстры
      </button>
    </div>

    <!-- Загрузка -->
    <div v-if="loading" class="text-center text-blue-500 text-xl">
      Загрузка...
    </div>

    <!-- Ошибка -->
    <div v-else-if="error" class="text-center text-red-500 text-xl">
      {{ error }}
    </div>

    <!-- Список данных -->
    <ul v-else class="space-y-4">
      <li
        v-for="(person, index) in filteredStaff"
        :key="person.id"
        class="flex items-center justify-between p-4 bg-white rounded-lg shadow hover:shadow-md transition"
      >
        <!-- Номер карточки -->
        <div class="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full font-bold">
          {{ index + 1 }}
        </div>

        <!-- Информация о человеке -->
        <div class="ml-4 flex-1">
          <h3 class="text-lg font-semibold text-gray-800">
            {{ person.full_name }}
          </h3>
          <p class="text-gray-600">
            <strong>Роль:</strong> {{ person.role === "doctor" ? "Врач" : "Медсестра" }}
          </p>
          <p class="text-gray-600">
            <strong>Город:</strong> {{ person.city }}
          </p>

          <!-- Опыт работы -->
          <div v-if="person.work_experience && person.work_experience.length" class="mt-2">
            <h4 class="text-gray-700 font-semibold">Опыт работы:</h4>
            <ul class="list-disc list-inside text-gray-600">
              <li v-for="(exp, index) in person.work_experience" :key="index">
                {{ exp.place }} — {{ exp.years }} лет
              </li>
            </ul>
          </div>
        </div>

        <!-- Кнопка "Подробнее" -->
        <button
          @click="goToDetails(person.id, person.role)"
          class="bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600 transition"
        >
          Подробнее
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import MedicalStaffService from "@/services/MedicalStaffService";

export default {
  data() {
    return {
      medicalStaff: [],
      filteredStaff: [],
      loading: true,
      error: null,
      filter: "all",
      searchQuery: "",
      activeClass: "bg-blue-500 text-white font-semibold px-4 py-2 rounded-full shadow-md",
      defaultClass: "bg-gray-200 text-gray-700 px-4 py-2 rounded-full hover:bg-gray-300 transition",
    };
  },
  watch: {
    searchQuery: "applyFilters",
    filter: "applyFilters",
  },
  methods: {
    async loadMedicalStaff() {
      try {
        this.medicalStaff = await MedicalStaffService.getMedicalStaff();
        this.filteredStaff = this.medicalStaff;
      } catch (err) {
        this.error = "Ошибка загрузки данных.";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    // Фильтруем данные
    applyFilters() {
      let result = this.medicalStaff;

      if (this.filter !== "all") {
        result = result.filter((person) => person.role === this.filter);
      }

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter((person) =>
          person.full_name.toLowerCase().includes(query)
        );
      }

      this.filteredStaff = result;
    },

    filterStaff(type) {
      this.filter = type;
    },

    // Переход на детальную страницу по ID
    goToDetails(id, role) {
  this.$router.push({ name: "MedicalStaffDetail", params: { id }, query: { role } });
},
  },
  created() {
    this.loadMedicalStaff();
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
</style>
